import { Controller } from '@hotwired/stimulus'

/**
 * Scrollable tabs controller - adds scroll indicators and buttons
 * when tabs overflow their container
 */
export default class extends Controller {
  static targets = ['nav', 'leftFade', 'rightFade', 'leftButton', 'rightButton']

  connect() {
    // Initial check after content loads
    requestAnimationFrame(() => {
      this.updateIndicators()
    })

    // Re-check on window resize
    this.resizeObserver = new ResizeObserver(() => {
      this.updateIndicators()
    })
    this.resizeObserver.observe(this.navTarget)
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  updateIndicators() {
    const nav = this.navTarget
    const scrollLeft = nav.scrollLeft
    const scrollWidth = nav.scrollWidth
    const clientWidth = nav.clientWidth
    const canScroll = scrollWidth > clientWidth + 1 // +1 for rounding

    // Show/hide left fade and button
    const showLeft = canScroll && scrollLeft > 5
    if (this.hasLeftFadeTarget) {
      this.leftFadeTarget.style.opacity = showLeft ? '1' : '0'
    }
    if (this.hasLeftButtonTarget) {
      this.leftButtonTarget.style.display = showLeft ? 'flex' : 'none'
      this.leftButtonTarget.style.opacity = showLeft ? '1' : '0'
    }

    // Show/hide right fade and button
    const showRight = canScroll && (scrollLeft + clientWidth) < (scrollWidth - 5)
    if (this.hasRightFadeTarget) {
      this.rightFadeTarget.style.opacity = showRight ? '1' : '0'
    }
    if (this.hasRightButtonTarget) {
      this.rightButtonTarget.style.display = showRight ? 'flex' : 'none'
      this.rightButtonTarget.style.opacity = showRight ? '1' : '0'
    }
  }

  scrollLeft() {
    this.navTarget.scrollBy({ left: -200, behavior: 'smooth' })
  }

  scrollRight() {
    this.navTarget.scrollBy({ left: 200, behavior: 'smooth' })
  }
}
